/* ============================================================
   Game trên URL — nguồn dùng chung cho TopBar (dải chọn game)
   và Homepage (thanh chuyển game + lọc danh sách acc).
   Link dạng /?game=lq sẽ mở đúng tab và cuộn tới thanh chọn game.
   ============================================================ */

/* key = giá trị post.thumb trong DB, slug = giá trị ngắn dùng trên URL

   Chỉ liệt kê game CÓ HÀNG trong kho. Free Fire từng nằm ở đây và sinh ra hai
   nút bấm vào là ra danh sách rỗng (dải chọn game ở TopBar, thanh chuyển game ở
   Homepage) — kho chưa từng có acc FF nào. Mời khách bấm rồi cho xem trang
   trống là cách nhanh nhất để họ thoát.

   Khi kho có acc FF thật thì thêm lại dòng:
     { key: "freefire", label: "Free Fire", tag: "FF", slug: "ff" },
   Alias "ff" bên dưới vẫn giữ nguyên nên link cũ chạy lại được ngay. */
export const GAMES = [
  { key: "crossFire", label: "CrossFire", tag: "CF", slug: "cf" },
  { key: "lienquan", label: "Liên Quân", tag: "LQ", slug: "lq" },
];

export const DEFAULT_GAME = "crossFire";

/* Game gắn cờ HOT trên dải chọn game của header.
   Đặt null để gỡ cờ khi không còn là mục mới. */
export const HOT_GAME = "lienquan";

/* Các cách viết được chấp nhận trên URL → key nội bộ.
   Hỗ trợ cả slug ngắn, tên đầy đủ lẫn chính key để link cũ/link tay đều chạy. */
const GAME_ALIASES = {
  cf: "crossFire",
  crossfire: "crossFire",
  "cross-fire": "crossFire",
  dotkich: "crossFire",
  "dot-kich": "crossFire",
  lq: "lienquan",
  lienquan: "lienquan",
  "lien-quan": "lienquan",
  ff: "freefire",
  freefire: "freefire",
  "free-fire": "freefire",
};

/* thumb trong DB → đường dẫn trang chủ đã chọn sẵn tab game đó.

     "crossFire" → "/?game=cf"
     "lienquan"  → "/?game=lq"

   Đây là "trang danh mục" thật của một game: vào là thấy kho acc đang cho
   thuê, đúng thứ khách bấm breadcrumb để tìm. Trang trụ cột tĩnh
   (/thue-acc-dot-kich/) là trang nội dung SEO, link tới nó lấy ở footer và ở
   các khối "xem toàn bộ", không phải ở breadcrumb.
   Game không có trong GAMES thì về trang chủ trơn. */
export function gameHomePathOf(thumb) {
  const game = GAMES.find((g) => g.key === thumb);
  return game ? `/?game=${game.slug}` : "/";
}

/* Đọc game từ URL: ưu tiên ?game=..., sau đó tới #... (hash).
   Trả về null nếu URL không chỉ định game, HOẶC chỉ định một game không còn
   trong GAMES.

   Vế thứ hai là chỗ dễ sót: GAME_ALIASES vẫn nhận "ff" để link cũ (/?game=ff
   đã phát ra ngoài, còn trong lịch sử duyệt và trong index của Google) không
   rơi vào nhánh lỗi. Nhưng trả thẳng "freefire" về cho Homepage thì nó đặt
   active = freefire và lọc ra danh sách rỗng — đúng cái ngõ cụt vừa gỡ. Lọc ở
   đây để cả TopBar lẫn Homepage cùng rơi về DEFAULT_GAME, vì cả hai đều viết
   `parseGameFromUrl(...) || DEFAULT_GAME`. */
export function parseGameFromUrl(search, hash) {
  const fromQuery = new URLSearchParams(search).get("game");
  // chấp nhận #lq, #game=lq, #game-lq
  const fromHash = (hash || "").replace(/^#/, "").replace(/^game[-=]/, "");
  const raw = (fromQuery || fromHash || "").trim().toLowerCase();
  const key = GAME_ALIASES[raw] || null;
  return GAMES.some((g) => g.key === key) ? key : null;
}
